// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- Due to migration with conv-ai-provider package
// @ts-nocheck
import { Grid } from '@rbx/ui';
import React, { FC, useMemo } from 'react';
import {
  FeedbackDialogType,
  ShareFeedbackProvider,
} from '@modules/feedback/context/ShareFeedbackProvider';
import {
  useProvidedConversationReducer,
  MessageRole,
  ConnectionState,
  MessageHistoryItem,
  MessageRequestType,
  isRateLimitError,
} from '@rbx/conv-ai-provider';
import { useAssistantOptIn } from '../context/AssistantOptInProvider';
import ConnectionStateAlert from './ConnectionStateAlert';
import ConversationErrorAlert from './ConversationErrorAlert';
import ConversationMessage from './ConversationMessage';
import OptInConversation from './OptInConversation';

const ConversationStream: FC<React.PropsWithChildren> = () => {
  const { processing: processingOptIn } = useAssistantOptIn();
  const {
    state: {
      streaming,
      connectionState,
      messageHistory,
      activeRequestId,
      activePromptMessage,
      activeResponseMessage,
      activeMessageConversationError,
      errorByMessageHistoryIdx,
      ratingByRequestId,
    },
  } = useProvidedConversationReducer();
  const connectionAlert = useMemo(
    () =>
      connectionState !== ConnectionState.Connected &&
      // rate limit errors should take the place of connection errors
      !isRateLimitError(activeMessageConversationError) && (
        <ConnectionStateAlert connectionState={connectionState} />
      ),
    [connectionState, activeMessageConversationError],
  );

  return (
    <ShareFeedbackProvider feedbackDialogType={FeedbackDialogType.RatedAssistantFeedback}>
      <Grid item XSmall={12}>
        {processingOptIn && <OptInConversation />}
        {messageHistory.map((message: MessageHistoryItem, i: number) =>
          message.context.requestType === MessageRequestType.RegenerationRequest &&
          message.role === MessageRole.User ? null : (
            <ConversationMessage
              // messages can have no message IDs if stopped before convo
              // was created / returned by server with message ID
              // so allow keying by message order (i)
              // eslint-disable-next-line react/no-array-index-key
              key={`${message.requestId}-${i}-${message.role}`}
              requestId={message.requestId}
              message={message}
              rating={message.requestId ? ratingByRequestId.get(message.requestId) : undefined}
              error={errorByMessageHistoryIdx.get(i)}
              isStreamingBotMessage={false}
            />
          ),
        )}
        {activePromptMessage &&
          activePromptMessage.context.requestType !== MessageRequestType.RegenerationRequest && (
            <ConversationMessage
              key={`${activeRequestId || 'active'}-user`}
              requestId={activeRequestId}
              message={activePromptMessage}
              isStreamingBotMessage={false}
            />
          )}
        {(streaming || activeResponseMessage) && (
          <ConversationMessage
            key={`${activeRequestId || 'streaming'}-bot`}
            requestId={activeRequestId}
            message={activeResponseMessage}
            isStreamingBotMessage={streaming}
          />
        )}
        {activeMessageConversationError && (
          <ConversationErrorAlert
            requestId={activeRequestId}
            message={activePromptMessage}
            error={activeMessageConversationError}
          />
        )}
        {connectionAlert}
      </Grid>
    </ShareFeedbackProvider>
  );
};

export default ConversationStream;
